module.exports = __webpack_public_path__ + "img/reason_01@2x.9e858b06.png";